import { obtenerToken, MSGERROR } from '../librerias/funciones'
import store from '../store';

const endpoint1 = ""
/*
==============Original=============
const endpointBackOffice =  "https://licencias.servicenext.eu/API/"
*/


const endpointBackOffice =  "https://sercasocio.servicenext.eu/API/"
//const endpoint1 = "http://86.109.106.108/API_NEXTASSIST_TALLER/"
//const endpoint2 = "https://nextassist.serca.es/API/"


let controller = new AbortController();

/*

const buscarMatriculaCocheV2 = (matricula) => {
    return axios({
        method: 'GET',
        url: endpoint1 + "api/TecnicoNextAssist/" + matricula,
    }).then(function (res) {
        if (res.data !== undefined) {
            if (!res.data.OK) {
                MSGERROR(res.data.MENSAJE_ERROR)
            }
            return res.data

    });
}



const GetSmartPackEnAPI = (ID_VEHICULO) => {

    return axios({
        method: 'post',
        url: endpoint2 + "api/Heynes/GetSmartPack",
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify({
            ID_VEHICULO: ID_VEHICULO,
            GRUPO: ""
        })
    }).then(function (res) {
        if (res.data !== undefined) {
            if (!res.data.OK) {
                MSGERROR(res.data.MENSAJE_ERROR)
            }
            return res.data
        }
    });
}





const GetDetalleSmartPackEnAPI = (ID_SISTEMA, TIPO_TBS) => {
    return axios({
        method: 'post',
        url: endpoint2 + "/api/Heynes/GetDetalleSmartPack",
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify({
            ID_SISTEMA: ID_SISTEMA,
            TIPO_TBS: TIPO_TBS
        })
    }).then(function (res) {
        if (res.data !== undefined) {
            if (!res.data.OK) {
                MSGERROR(res.data.MENSAJE_ERROR)
            }
            return res.data
        }
    });
}
*/



const LoginEnAPI = (USUARIO, PWD) => {
    //  return fetch(endpoint1 + 'Accesos/Login', {
        //https://assist.servicenext.eu/test/Accesos/Login
    controller = new AbortController();
    return fetch(endpointBackOffice + 'Api/Login/LoginNextGroup', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                USUARIO: USUARIO,
                PWD: PWD
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                /*
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                */
                return res;
            }
        })
}


const LogoutEnAPI = () => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Login/LogOut', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res;
            }
        })
}


const obtener_registros_paginadosEnAPI = (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, INCLUIR_BAJAS, INCLUIR_CERRADAS, ID_TALLER, ID_USUARIO_TALLER, FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA) => {
    controller = new AbortController();
    // 'Tareas/obtener_registros_paginados'
    //return fetch(endpoint1 +  'Tareas/obtener_registros_paginados', {
    //https://assist.servicenext.eu/test/tareas/actualizar_feedback

    return fetch(endpoint1 +  'Tareas/obtener_registros_paginados', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGSPAGE: REGSPAGE,
                PAGE: PAGE,
                ORDERCOLUM: ORDERCOLUM,
                ORDERDIR: ORDERDIR,
                //INCLUIR_BAJAS: INCLUIR_BAJAS,  
                INCLUIR_CERRADAS: INCLUIR_CERRADAS,
                //ID_TALLER:ID_TALLER,
                //ID_USUARIO_TALLER:ID_USUARIO_TALLER,
                FECHA_PARTIDA: FECHA_PARTIDA,
                ACCION_DESDE: ACCION_DESDE,
                ACCION_HASTA: ACCION_HASTA,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res;
            }
        })
}



const obtener_fabricantesEnAPI = (TIPO_VEHICULO) => {
    controller = new AbortController();
    return fetch(endpoint1 + 'VehiculoTecdoc/obtener_fabricantes', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                TIPO_VEHICULO: TIPO_VEHICULO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}

const obtener_modelosEnAPI = (FABRICNATE) => {
    controller = new AbortController();
    return fetch(endpoint1 + 'VehiculoTecdoc/obtener_modelos', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                FABRICANTE: FABRICNATE,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}

const obtener_motorizacionesEnAPI = (ID_MODELO) => {
    controller = new AbortController();
    return fetch(endpoint1 + 'VehiculoTecdoc/obtener_motorizaciones', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_MODELO: ID_MODELO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const obtener_tipo_tareaEnAPI = () => {
    controller = new AbortController();
    return fetch(endpoint1 + 'Maestras/obtener_tipo_tarea', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const obtener_grupo_montajeEnAPI = () => {
    controller = new AbortController();
    return fetch(endpoint1 + 'Maestras/obtener_grupo_montaje', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const obtener_estados_tareaEnAPI = () => {
    controller = new AbortController();
    return fetch(endpoint1 + 'Maestras/obtener_estados_tarea', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const obtener_paises_EnAPI = () => {
    controller = new AbortController();
    return fetch(endpoint1 + 'Maestras/obtener_paises', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const buscar_matriculaEnAPI = (MATRICULA,PAIS) => {
    controller = new AbortController();
    return fetch(endpoint1 + 'Matriculas/buscar_matricula', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                MATRICULA: MATRICULA,
                PAIS:PAIS,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const buscar_bastidorEnAPI = (BASTIDOR,PAIS) => {
    controller = new AbortController();
    return fetch(endpoint1 + 'Matriculas/buscar_bastidor', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                BASTIDOR: BASTIDOR,
                PAIS:PAIS,

                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}

const obtener_fichero_tecnico_EnAPI = (ID) => {
    controller = new AbortController();
    return fetch(endpoint1 + 'Archivos/Tecnico/obtener', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID: ID,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}
const obtener_fichero_taller_EnAPI = (ID) => {
    controller = new AbortController();
    return fetch(endpoint1 + 'Archivos/obtener', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID: ID,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const obtener_registrosEnAPI = (ID_TAREA) => {
    controller = new AbortController();
    return fetch(endpoint1 + 'Archivos/Tecnico/obtener_registros', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_TAREA: ID_TAREA,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const obtener_registros_taller_EnAPI = (ID_TAREA) => {
    controller = new AbortController();
    return fetch(endpoint1 + 'Archivos/obtener_registros', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_TAREA: ID_TAREA,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const insertar_ficheroEnAPI = (ID_TAREA, NOMBRE, EXTENSION, DATOS) => {
    controller = new AbortController();
    return fetch(endpoint1 + 'Archivos/insertar', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_TAREA: ID_TAREA,
                NOMBRE: NOMBRE,
                EXTENSION: EXTENSION,
                DATOS: DATOS,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const nueva_tareaEnAPI = (PAYLOAD) => {
    controller = new AbortController();
    return fetch(endpoint1 + 'Tareas/nuevo', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_MAE_PAIS_TAREA: PAYLOAD.ID_MAE_PAIS_TAREA,
                ID_VEHICULO_TECDOC: PAYLOAD.ID_VEHICULO_TECDOC,
                MATRICULA_MARCA_ID: PAYLOAD.MATRICULA_MARCA_ID,
                MATRICULA_MODELO_ID: PAYLOAD.MATRICULA_MODELO_ID,
                MATRICULA_MOTOR_ID: PAYLOAD.MATRICULA_MOTOR_ID,
                BASTIDOR: PAYLOAD.BASTIDOR,
                MATRICULA: PAYLOAD.MATRICULA,
                MATRICULA_MARCA: PAYLOAD.MATRICULA_MARCA,
                MATRICULA_MODELO: PAYLOAD.MATRICULA_MODELO,
                MATRICULA_MOTOR: PAYLOAD.MATRICULA_MOTOR,
                MATRICULA_CODIGO_MOTOR: PAYLOAD.MATRICULA_CODIGO_MOTOR,
                MATRICULA_PAIS: PAYLOAD.MATRICULA_PAIS,
                ID_TALLER: PAYLOAD.ID_TALLER,
                ID_MAE_PLATAFORMA: PAYLOAD.ID_MAE_PLATAFORMA,
                ID_MAE_GRUPO_MONTAJE: PAYLOAD.ID_MAE_GRUPO_MONTAJE,
                ID_MAE_PRIORIDAD_TAREA: PAYLOAD.ID_MAE_PRIORIDAD_TAREA,
                ID_MAE_TIPO_TAREA: PAYLOAD.ID_MAE_TIPO_TAREA,
                TEXTO: PAYLOAD.TEXTO,
                CODIGO_AVERIA: PAYLOAD.CODIGO_AVERIA,
                TEXTO_RESPUESTA: PAYLOAD.TEXTO_RESPUESTA,
                ID_MAE_GRADO_SATISFACCION: PAYLOAD.ID_MAE_GRADO_SATISFACCION,
                RESOLUCION_DE_TAREAS: PAYLOAD.RESOLUCION_DE_TAREAS,
                ID_MAE_ESTADO_TAREA: PAYLOAD.ID_MAE_ESTADO_TAREA,
                ID_USUARIO_ASIGNADO: PAYLOAD.ID_USUARIO_ASIGNADO,
                ID_USUARIO_EN_CURSO: PAYLOAD.ID_USUARIO_EN_CURSO,
                ID_USUARIO_RESPUESTA: PAYLOAD.ID_USUARIO_RESPUESTA,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetSmartPackEnAPI = (ID_VEHICULO_TECDOC) => {
    controller = new AbortController();
    let HEYNES_TOKEN = store.getState().usuario.HEYNES_SMART_TOKEN;

    return fetch(endpoint1 + 'Heynes/obtener_boletines_reparacion', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_VEHICULO_TECDOC: ID_VEHICULO_TECDOC,
            GRUPO: "",
            HEYNES_SMART_TOKEN: HEYNES_TOKEN,

            Token: obtenerToken()
        }

        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}

const GetDetalleSmartPackEnAPI = (ID_SISTEMA, TIPO_TBS) => {
    controller = new AbortController();
    let HEYNES_TOKEN = store.getState().usuario.HEYNES_SMART_TOKEN;

    return fetch(endpoint1 + 'Heynes/obtener_detalle_boletin', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_SISTEMA: ID_SISTEMA,
                TIPO_TBS: TIPO_TBS,

                HEYNES_SMART_TOKEN: HEYNES_TOKEN,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const obtener_vehiculoEnAPI = (ID_VEHICULO) => {
    controller = new AbortController();

    return fetch(endpoint1 + 'VehiculoTecdoc/obtener_vehiculo', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_VEHICULO: ID_VEHICULO,

                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const obtener_imagen_vehiculoEnAPI = (ID_VEHICULO) => {
    controller = new AbortController();
    let HEYNES_TOKEN = store.getState().usuario.HEYNES_DIST_TOKEN;

    return fetch(endpoint1 + 'VehiculoTecdoc/obtener_imagen_vehiculo', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_VEHICULO_TECDOC: ID_VEHICULO,
                HEYNES_DIST_TOKEN: HEYNES_TOKEN,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const recuperar_contrasenyaEnAPI = (CORREO) => {
    controller = new AbortController();

    return fetch(endpoint1 + 'Accesos/recuperar_contrasenya', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                CORREO_ELECTRONICO: CORREO,
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const obtener_usuario_EnAPI = () => {
    controller = new AbortController();

    return fetch(endpoint1 + 'Usuario/obtener', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const actualizar_usuario_EnAPI = (PAYLOAD, PWD) => {
    controller = new AbortController();

    return fetch(endpoint1 + 'Usuario/actualizar', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                USUARIO: PAYLOAD.USUARIO,
                PWD: PWD,
                ID_IDIOMA: PAYLOAD.ID_IDIOMA,
                CORREO_RECUPERACION_PWD: PAYLOAD.CORREO_RECUPERACION_PWD,
                OBSERVACIONES: PAYLOAD.OBSERVACIONES,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const obtener_registros_idiomas_EnAPI = (ORDERCOLUM, ORDERDIR) => {
    controller = new AbortController();

    return fetch(endpoint1 + 'Idiomas/obtener_registros', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ORDERCOLUM: ORDERCOLUM,
                ORDERDIR: ORDERDIR,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const obtener_configuracion_EnAPI = () => {
    controller = new AbortController();

    return fetch(endpoint1 + 'Configuracion/obtener', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {

                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const obtener_tarea_EnAPI = (ID) => {
    controller = new AbortController();

        return fetch(endpoint1 + 'Tareas/obtener', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID: ID,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const obtener_anyos_EnAPI = () => {
    controller = new AbortController();

    return fetch(endpoint1 + 'Tareas/anyos', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const obtener_grado_satisfaccionEnAPI = () => {
    controller = new AbortController();
    return fetch(endpoint1 + 'Maestras/obtener_grado_satisfaccion', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const hay_feedback_pendientesEnAPI = () => {
    controller = new AbortController();
    return fetch(endpoint1 + "Tareas/hay_feedback_pendientes", {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const actualizar_feedbackEnAPI = (ID_TAREA,ID_GRADO,TEXTO_RESOLUCION) => {
    controller = new AbortController();
    return fetch(endpoint1 + "tareas/actualizar_feedback", {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID:ID_TAREA,
                ID_MAE_GRADO_SATISFACCION:ID_GRADO,
                RESOLUCION_DE_TAREAS:TEXTO_RESOLUCION,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}

const documento_consutlaEnAPI = (ID) => {
    controller = new AbortController();
    return fetch(endpoint1 +  "tareas/documento_consulta", {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID:ID,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const obtener_conectorEnAPI = (ID_VEHICULO,CODIGO_MOTOR) => {
    controller = new AbortController();
    return fetch(endpoint1 +  "VehiculoTecdoc/obtener_conector", {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_VEHICULO:ID_VEHICULO,
                CODIGO_MOTOR:CODIGO_MOTOR,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}









const GetCategoriaDocumentoEnAPI = (ORDERCOLUM, ORDERDIR, ID, NOMBRE, DESCRIPCION) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetCategoriaDocumento', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 1000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            NOMBRE: NOMBRE,
            DESCRIPCION: DESCRIPCION,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const SetCategoriaDocumentoEnAPI = (ACCION, ID, NOMBRE, DESCRIPCION) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetCategoriaDocumento', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: ID,
            NOMBRE: NOMBRE,
            DESCRIPCION: DESCRIPCION,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}





const GetTipoDocumentoEnAPI = (ORDERCOLUM, ORDERDIR, ID, NOMBRE, DESCRIPCION, EXTENSION) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetTipoDocumento', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 1000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            NOMBRE: NOMBRE,
            DESCRIPCION: DESCRIPCION,
            EXTENSION: EXTENSION,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const SetTipoDocumentoEnAPI = (ACCION, ID, NOMBRE, DESCRIPCION, EXTENSION) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetTipoDocumento', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: ID,
            NOMBRE: NOMBRE,
            DESCRIPCION: DESCRIPCION,
            EXTENSION: EXTENSION,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetMarcasEnAPI = (ORDERCOLUM, ORDERDIR, ID, NOMBRE, ID_TECDOC, BLANCA, DESTACADA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetMarcas', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 5000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            NOMBRE: NOMBRE,
            ID_TECDOC: ID_TECDOC,
            BLANCA: BLANCA,
            DESTACADA: DESTACADA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const SetMarcaEnAPI = (ACCION, ID, NOMBRE, ID_TECDOC, BLANCA, DESTACADA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetMarca', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: ID,
            NOMBRE: NOMBRE,
            ID_TECDOC: ID_TECDOC,
            BLANCA: BLANCA,
            DESTACADA: DESTACADA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}





const GetCategoriaNoticiaEnAPI = (ORDERCOLUM, ORDERDIR, ID, NOMBRE, DESCRIPCION, DESTACADA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetCategoriaNoticia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 1000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            NOMBRE: NOMBRE,
            DESCRIPCION: DESCRIPCION,
            DESTACADA: DESTACADA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const SetCategoriaNoticiaEnAPI = (ACCION, ID, NOMBRE, DESCRIPCION, DESTACADA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetCategoriaNoticia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: ID,
            NOMBRE: NOMBRE,
            DESCRIPCION: DESCRIPCION,
            DESTACADA: DESTACADA,

            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}





const GetEstadoNoticiaEnAPI = (ORDERCOLUM, ORDERDIR, ID, DESCRIPCION) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetEstadoNoticia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 1000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            DESCRIPCION: DESCRIPCION,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const SetEstadoNoticiaEnAPI = (ACCION, ID, DESCRIPCION) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetEstadoNoticia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: ID,
            DESCRIPCION: DESCRIPCION,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetTipoNoticiaEnAPI = (ORDERCOLUM, ORDERDIR, ID, NOMBRE, DESCRIPCION) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetTipoNoticia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 1000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            NOMBRE: NOMBRE,
            DESCRIPCION: DESCRIPCION,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const SetTipoNoticiaEnAPI = (ACCION, ID, NOMBRE, DESCRIPCION, ID_PLANTILLA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetTipoNoticia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: ID,
            NOMBRE: NOMBRE,
            DESCRIPCION: DESCRIPCION,
            ID_PLANTILLA: ID_PLANTILLA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetPlantillaTipoNoticiaEnAPI = (ORDERCOLUM, ORDERDIR, ID, NOMBRE) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetPlantillaTipoNoticia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 1000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            NOMBRE: NOMBRE,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const SetPlantillaTipoNoticiaEnAPI = (ACCION, ID, NOMBRE, CONTENIDO, ASUNTO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetPlantillaTipoNoticia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: ID,
            NOMBRE: NOMBRE,
            CONTENIDO: CONTENIDO,
            ASUNTO: ASUNTO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetTipoEntidadEnAPI = (ORDERCOLUM, ORDERDIR, ID, NOMBRE) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetTipoEntidad', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 1000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            NOMBRE: NOMBRE,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const SetTipoEntidadEnAPI = (ACCION, ID, NOMBRE, DESCRIPCION) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetTipoEntidad', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: ID,
            NOMBRE: NOMBRE,
            DESCRIPCION: DESCRIPCION,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetProveedoresEnAPI = (ORDERCOLUM, ORDERDIR, ID) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetProveedores', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 1000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}





const GetProveedorDetalleEnAPI = (ID) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetProveedorDetalle', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID: ID,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const SetDocumentoProveedorEnAPI = (ACCION, PAYLOAD) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetDocumentoProveedor', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: PAYLOAD.ID,
            ID_PROVEEDOR: PAYLOAD.ID_PROVEEDOR,
            ID_CATEGORIA_DOCUMENTO: PAYLOAD.ID_CATEGORIA_DOCUMENTO,
            ID_PAIS: PAYLOAD.ID_PAIS,
            ANYO: PAYLOAD.ANYO,
            NOMBRE: PAYLOAD.NOMBRE,
            EXTENSION: PAYLOAD.EXTENSION,
            DATOS: PAYLOAD.DATOS,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}





const GetDocumentoProveedorEnAPI = (ID, ID_PROVEEDOR) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetDocumentoProveedor', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID: ID,
            ID_PROVEEDOR: ID_PROVEEDOR,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}







const GetCarpetaDocEnAPI = (ORDERCOLUM, ORDERDIR, ID) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetCarpetas', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 5000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const SetCarpetaDocEnAPI = (ACCION, ID, ID_PADRE, NOMBRE) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetCarpetaDoc', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: ID,
            ID_PADRE: ID_PADRE,
            NOMBRE: NOMBRE,


            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetCarpetaDocDocumentoEnAPI = (ORDERCOLUM, ORDERDIR, ID, ID_CARPETA, ID_DOCUMENTO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetCarpetaDocDocumento', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 0,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            ID_CARPETA: ID_CARPETA,
            ID_DOCUMENTO: ID_DOCUMENTO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const SetCarpetaDocDocumentoEnAPI = (ACCION, ID, ID_PADRE, NOMBRE, EXTENSION, DATOS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetCarpetaDocDocumento', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: ID,
            ID_CARPETA: ID_PADRE,
            NOMBRE: NOMBRE,
            EXTENSION: EXTENSION,
            DATOS: DATOS,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const GetSociosExcluidosCarpetaEnAPI = (ORDERCOLUM, ORDERDIR, ID, ID_CARPETA, ID_SOCIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetSociosExcluidosCarpeta', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 5000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            ID_CARPETA: ID_CARPETA,
            ID_SOCIO: ID_SOCIO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const SetSociosExcluidosCarpetaEnAPI = (ACCION, ID_CARPETA, ID_SOCIOS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetSociosExcluidosCarpeta', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID_CARPETA: ID_CARPETA,
            ID_SOCIOS: ID_SOCIOS,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetSociosExcluidosDocumentoEnAPI = (ORDERCOLUM, ORDERDIR, ID, ID_CARPETA, ID_DOCUMENTO, ID_SOCIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetSociosExcluidosDocumento', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 5000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            ID_CARPETA: ID_CARPETA,
            ID_DOCUMENTO: ID_DOCUMENTO,
            ID_SOCIO: ID_SOCIO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const SetSociosExcluidosDocumentoEnAPI = (ACCION, ID_CARPETA, ID_DOCUMENTO, ID_SOCIOS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetSociosExcluidosDocumento', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID_CARPETA: ID_CARPETA,
            ID_DOCUMENTO: ID_DOCUMENTO,
            ID_SOCIOS: ID_SOCIOS,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}





const GetNoticiasEnAPI = (ORDERCOLUM, ORDERDIR, ID, FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA,KEYWORDS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetNoticias', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 10000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            FECHA_PARTIDA: FECHA_PARTIDA,
            ACCION_DESDE: ACCION_DESDE,
            ACCION_HASTA: ACCION_HASTA,
            KEYWORDS:KEYWORDS,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const SetNoticiaEnAPI = (ACCION, PAYLOAD) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetNoticia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: PAYLOAD.ID,
            NUMERO: PAYLOAD.NUMERO,
            TITULO: PAYLOAD.TITULO,
            FECHA_PUBLICACION: PAYLOAD.FECHA_PUBLICACION,
            FECHA: PAYLOAD.FECHA,
            ID_ESTADO_NOTICIA: PAYLOAD.ID_ESTADO_NOTICIA,
            ID_NOTICIA_TIPO: PAYLOAD.ID_NOTICIA_TIPO,
            TEXTO: PAYLOAD.TEXTO,
            ENVIADA: PAYLOAD.ENVIADA,
            TEXTO_LIMPIO: PAYLOAD.TEXTO_LIMPIO,
            KEYWORDS: PAYLOAD.KEYWORDS,
            DESTACADA: PAYLOAD.DESTACADA,

            ID_CATEGORIAS: PAYLOAD.ID_CATEGORIAS,
            NOMBRE_IMAGEN: PAYLOAD.NOMBRE_IMAGEN,
            EXTENSION_IMAGEN: PAYLOAD.EXTENSION_IMAGEN,
            DATOS_IMAGEN: PAYLOAD.DATOS_IMAGEN,
            DOCUMENTOS_AGREGAR: PAYLOAD.DOCUMENTOS_AGREGAR,
            DOCUMENTOS_ELIMINAR: PAYLOAD.DOCUMENTOS_ELIMINAR,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const SetNoticiaImagenEnAPI = (ACCION, PAYLOAD) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetNoticiaImagen', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: PAYLOAD.ID,
            ID_NOTICIA: PAYLOAD.ID_NOTICIA,
            NOMBRE: PAYLOAD.NOMBRE,
            EXTENSION: PAYLOAD.EXTENSION,
            DATOS: PAYLOAD.DATOS,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const CruzarReferenciasPorGrupoMontajeEnAPI = (MARCA_ORIGEN, GRUPOS_MONTAJE, MARCAS_DESTINO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/CruzarReferenciasPorGrupoMontaje', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            MARCA_ORIGEN: MARCA_ORIGEN,
            GRUPOS_MONTAJE: GRUPOS_MONTAJE,
            MARCAS_DESTINO: MARCAS_DESTINO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const CruzarReferenciasPorGrupoMontajeImpresionEnAPI = (TIPO_IMPRESION, REGISTROS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/CruzarReferenciasPorGrupoMontajeImpresion', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            TIPO_IMPRESION: TIPO_IMPRESION,
            REGISTROS: REGISTROS,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}









const PublicarNoticiaEnAPI = (ID, FECHA_PUBLICACION,CON_ENVIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/PublicarNoticia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID: ID,
            FECHA_PUBLICACION: FECHA_PUBLICACION,
            CON_ENVIO:CON_ENVIO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const MaquetarNoticiaEnAPI = (ID, TOKEN) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/MaquetarNoticia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID: ID,
            TOKEN: TOKEN,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetFamiliasEnAPI = (ORDERCOLUM, ORDERDIR,ID,NOMBRE) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetFamilias', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 10000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            NOMBRE: NOMBRE,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const SetFamiliaEnAPI = (ACCION, ID,NOMBRE) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetFamilia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID:ID,
            NOMBRE:NOMBRE,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetSubFamiliasEnAPI = (ORDERCOLUM, ORDERDIR,ID,ID_FAMILIA,NOMBRE) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetSubFamilias', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 10000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            ID_FAMILIA:ID_FAMILIA,
            NOMBRE: NOMBRE,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const SetSubFamiliaEnAPI = (ACCION,ID,NOMBRE,ID_FAMILIA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetSubFamilia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID:ID,
            ID_FAMILIA:ID_FAMILIA,
            NOMBRE:NOMBRE,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetArticulosEnAPI = (ORDERCOLUM, ORDERDIR,ID,ID_MARCA,ID_GRUPO_MONTAJE,ID_FAMILIA,ID_SUBFAMILIA,REFERENCIA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetArticulos', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 1000000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            ID_MARCA:ID_MARCA,
            ID_GRUPO_MONTAJE:ID_GRUPO_MONTAJE,
            ID_FAMILIA: ID_FAMILIA,
            ID_SUBFAMILIA:ID_SUBFAMILIA,
            REFERENCIA:REFERENCIA,

            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const SetArticulosEnAPI = (ACCION,PAYLOAD) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetArticulo', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID:PAYLOAD.ID,
            ID_MARCA:PAYLOAD.ID_MARCA,
            ID_FAMILIA:PAYLOAD.ID_FAMILIA,
            ID_SUBFAMILIA:PAYLOAD.ID_SUBFAMILIA,
            REFERENCIA:PAYLOAD.REFERENCIA,
   
            DESCRIPCION:PAYLOAD.DESCRIPCION,
            HOMOLOGADA:PAYLOAD.HOMOLOGADA,
            ID_GRUPO_MONTAJE_TECDOC:PAYLOAD.ID_GRUPO_MONTAJE_TECDOC,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetGruposMontajeEnAPI = (ID_MARCA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetGruposMontaje', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_MARCA:ID_MARCA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const SetMarcaProveedorEnAPI = (ACCION,ID,ID_PROVEEDOR,ID_MARCA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/SetMarcaProveedor', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION : ACCION,
            ID : ID,
            ID_PROVEEDOR : ID_PROVEEDOR,
            ID_MARCA : ID_MARCA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const ObtenerTarifaPorProveedorMarcaEnAPI = (REGSPAGE,PAGE,ORDERCOLUM,ORDERDIR, ID_PROVEEDOR,ID_MARCA,REFERENCIA_LIMPIA,ID_FAMILIA,VER_SIN_PRECIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/ObtenerTarifaPorProveedorMarca', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: REGSPAGE,
            PAGE: PAGE,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID_PROVEEDOR: ID_PROVEEDOR,
            ID_MARCA:ID_MARCA,
            REFERENCIA_LIMPIA:REFERENCIA_LIMPIA,
            ID_FAMILIA:ID_FAMILIA,
            VER_SIN_PRECIO:VER_SIN_PRECIO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}





const ObtenerTarifaPorActualizacionEnAPI = (REGSPAGE,PAGE,ORDERCOLUM,ORDERDIR,ID_ACTUALIZACION,REFERENCIA,ID_FAMILIA,VER_SIN_PRECIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/ObtenerTarifaPorActualizacion', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: REGSPAGE,
            PAGE: PAGE,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID_ACTUALIZACION: ID_ACTUALIZACION,
            REFERENCIA:REFERENCIA,
            ID_FAMILIA:ID_FAMILIA,
            VER_SIN_PRECIO:VER_SIN_PRECIO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const ObtenerFamiliasByMarcaEnAPI  = (ID_PROVEEDOR,ID_MARCA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/ObtenerFamiliasByMarca', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_PROVEEDOR : ID_PROVEEDOR,
            ID_MARCA : ID_MARCA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const TarifaProvedorMarcaDescagarCSVEnAPI  = (ID_PROVEEDOR,ID_MARCA,PROVEDOR_MARCA,ENCABEZADOS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/TarifaProvedorMarcaDescagarCSV', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_PROVEEDOR : ID_PROVEEDOR,
            ID_MARCA : ID_MARCA,
            PROVEDOR_MARCA:PROVEDOR_MARCA,
            ENCABEZADOS:ENCABEZADOS,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const TarifaActualizacionDescagarCSVEnAPI  = (ID_ACTUALIZACION,MARCA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/TarifaActualizacionDescagarCSV', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_ACTUALIZACION : ID_ACTUALIZACION,
            MARCA:MARCA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}






const ObtenerListaMarcasTecdocEnAPI = (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID) => {
    //let codmotorizacion = store.getState().codmotorizacion;
    controller = new AbortController();

    return fetch(endpointBackOffice + 'api/Marcas/ObtenerListaMarcasTecdoc', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGSPAGE: REGSPAGE,
                PAGE: PAGE,
                ORDERCOLUM: ORDERCOLUM,
                ORDERDIR: ORDERDIR,
                ID: ID,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const DarBajaLicenciaSertecEnAPI = (ID_USUARIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/UsuarioSertec/DarBajaLicenciaSertec', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_USUARIO: ID_USUARIO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const EnviarCorreoRecuperacionUsuarioSertecEnAPI = (ID_USUARIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + "api/UsuarioSertec/EnviarCorreoRecuperacionUsuarioSertec", {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_USUARIO: ID_USUARIO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                    return res;
                } else {
                    return res;
                }
            }
        })
}



const GetPaisesEnAPI = (ORDERCOLUM, ORDERDIR, ID, CODIGO, NOMBRE) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Pais/GetPaises', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 1000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            CODIGO: CODIGO,
            NOMBRE: NOMBRE,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const ObtenerGruposMontajeMarcasTecdocEnAPI = (ID_MARCA) => {
    //let codmotorizacion = store.getState().codmotorizacion;
    controller = new AbortController();

    return fetch(endpointBackOffice + 'api/Marcas/ObtenerGruposMontajeMarcasTecdoc', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_MARCA: ID_MARCA,

                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const ObtenerSocioEnAPI = () => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Socio/ObtenerSocio', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGSPAGE: 1000,
                PAGE: 1,
                ORDERCOLUM: 1,
                ORDERDIR: "A",
                NOMBRE: "",
                ID: 0,
                CIF: "",
                PROVINCIA: "",
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res.Lista_Socios
            }
        })
}



const GetIdiomasEnAPI = () => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Usuario/GetIdiomas', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGSPAGE: 100,
                PAGE: 1,
                ORDERCOLUM: 1,
                ORDERDIR: "A",
                ID: 0,
                NOMBRE: "",
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res.IDIOMAS
            }
        })
}




const GetNextAssistBODepartamentosEnAPI = (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID, NOMBRE) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetNextAssistBODepartamentos', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: REGSPAGE,
            PAGE: PAGE,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            NOMBRE: NOMBRE,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const GetRolesEnAPI = () => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Usuario/GetRoles', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGSPAGE: 100,
                PAGE: 1,
                ORDERCOLUM: 1,
                ORDERDIR: "A",
                ID: 0,
                NOMBRE: "",
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res.ROLES
            }
        })
}


const GetUsuariosEnAPI = (ID, USUARIO, ORDERDIR, ID_SOCIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Usuario/GetUsuarios', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGSPAGE: 50000,
                PAGE: 1,
                ORDERCOLUM: 1,
                ORDERDIR: ORDERDIR,
                ID: ID,
                USUARIO: USUARIO,
                NOMBRE_USUARIO: "",
                NOMBRE_SOCIO: "",
                ID_SOCIO: ID_SOCIO,
                BAJA: 0,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res.USUARIOS
            }
        })
}


const ObtenerRedesEnAPI = (NOMBRE, ORDERDIR) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Redes/ObtenerRedes', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGSPAGE: 50000,
                PAGE: 1,
                ORDERCOLUM: 1,
                ORDERDIR: ORDERDIR,
                NOMBRE: NOMBRE,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const SetUsuarioEnAPI = (payload, passwordUser, idioma, ID_ROL, IDS_SOCIO, ACCION, IDS_REDES, IDS_DEPARTAMENTOS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Usuario/SetUsuario', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ACCION: ACCION,
                ID: payload.ID,
                USUARIO: payload.USUARIO,
                PWD: passwordUser,
                NOMBRE: payload.NOMBRE,
                ID_IDIOMA: idioma,
                BAJA: payload.BAJA,
                CORREO_RECUPERACION_PWD: payload.CORREO_RECUPERACION_PWD,
                OBSERVACIONES: payload.OBSERVACIONES,
                ID_ROL: ID_ROL,
                IDS_SOCIOS: IDS_SOCIO,
                IDS_REDES: IDS_REDES,
                PERMISO_VONZU: payload.PERMISO_VONZU,
                USUARIO_VONZU: payload.USUARIO_VONZU,
                PWD_VONZU: payload.PWD_VONZU,
                DOMINIO_VONZU: payload.DOMINIO_VONZU,
                IDS_DEPARTAMENTOS: IDS_DEPARTAMENTOS,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const RecuperarPwdEnAPI = (EMAIL) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Login/RecuperarPwd', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                EMAIL: EMAIL
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}





const ValidarTarifaEnAPI = (PAYLOAD,CSV) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/ValidarTarifa', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_PROVEEDOR:PAYLOAD.ID_PROVEEDOR,
                ID_MARCA:PAYLOAD.ID_MARCA,
                FECHA_VIGENCIA:PAYLOAD.FECHA_VIGENCIA,
                ES_IMPORTE_PVP:PAYLOAD.ES_IMPORTE_PVP,
                CSV: CSV,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GuardarTarifaEnAPI = (TARIFA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GuardarTarifa', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
 
                TARIFA: TARIFA,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetLicenciasSertecSocioEnAPI = (ORDERCOLUM, ORDERDIR, ID_SOCIO, ID_USUARIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + "api/Socio/GetLicenciasSertecSocio", {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID: ID_USUARIO,
                REGSPAGE: 10000,
                PAGE: 1,
                ORDERCOLUM: ORDERCOLUM,
                ORDERDIR: ORDERDIR,
                ID_SOCIO: ID_SOCIO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                    return res;
                } else {
                    return res;
                }
            }
        })
}



const ObtenerClientesSocioEnAPI = (ID_SOCIO, ID_TIENDA_RETAIL, ID_TIPO_INTEGRACION) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Socio/ObtenerClientesSocio', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_SOCIO: ID_SOCIO,
                ID_TIENDA_RETAIL: ID_TIENDA_RETAIL,
                ID_TIPO_INTEGRACION: ID_TIPO_INTEGRACION,
                CLIENTE: "",
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res.CLIENTES
            }
        })
}


const ObtenerListadoLicenciasSertecCSVEnAPI = (LICENCIAS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Socio/ObtenerListadoLicenciasSertecCSV', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {

                LICENCIAS: LICENCIAS,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const ObtenerListadoLicenciasSertecHTMLEnAPI = (payLoadLocal) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Socio/ObtenerListadoLicenciasSertecHTML', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                LICENCIAS: payLoadLocal,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res.HTML
            }
        })
}


const ObtenerListadoLicenciasSertecPDFEnAPI = (payLoadLocal) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Socio/ObtenerListadoLicenciasSertecPDF', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                LICENCIAS: payLoadLocal,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const EstadisticasSertecMensualesPorUsuarioCSVEnAPI = (ID_USUARIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Estadisticas/EstadisticasSertecMensualesPorUsuarioCSV', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_USUARIO: ID_USUARIO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const GetEstadisticasMatriculasPorUsuarioDetalleEnAPI = (FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA, PLATAFORMA, ID_USUARIO_PLATAFORMA, CONSULTA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Estadisticas/GetEstadisticasMatriculasPorUsuarioDetalle', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                FECHA_PARTIDA: FECHA_PARTIDA,
                ACCION_DESDE: ACCION_DESDE,
                ACCION_HASTA: ACCION_HASTA,
                PLATAFORMA: PLATAFORMA,
                ID_USUARIO_PLATAFORMA: ID_USUARIO_PLATAFORMA,
                CONSULTA: CONSULTA,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const GetEstadisticasMatriculasPorUsuarioEnAPI = (FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA, PLATAFORMA, ID_USUARIO_PLATAFORMA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Estadisticas/GetEstadisticasMatriculasPorUsuario', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                FECHA_PARTIDA: FECHA_PARTIDA,
                ACCION_DESDE: ACCION_DESDE,
                ACCION_HASTA: ACCION_HASTA,
                PLATAFORMA: PLATAFORMA,
                ID_USUARIO_PLATAFORMA: ID_USUARIO_PLATAFORMA,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetEstadisticasSertecMensualesPorUsuarioEnAPI = (ID_USUARIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Estadisticas/GetEstadisticasSertecMensualesPorUsuario', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_USUARIO: ID_USUARIO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const GetEstadisticasTotalesAnnosEnAPI = (FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA, SOCIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Matricula/GetEstadisticasTotalesAnnos', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                FECHA_PARTIDA: FECHA_PARTIDA,
                ACCION_DESDE: ACCION_DESDE,
                ACCION_HASTA: ACCION_HASTA,
                PLATAFORMA: "SERTEC",
                SOCIO: SOCIO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const CargaMasivaClientesEnAPI = (ID_SOCIO, EXCEL_BYTES, BORRAR_ANTERIORES) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + "api/Socio/CargaMasivaClientes", {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_SOCIO: ID_SOCIO,
                EXCEL_BYTES: EXCEL_BYTES,
                BORRAR_ANTERIORES: BORRAR_ANTERIORES,

                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                    return res;
                } else {
                    return res;
                }
            }
        })
}



const CrearLicenciaClienteEnAPI = (payLoadLocal, Seleccionado) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/UsuarioSertec/CrearLicencia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                USUARIO: payLoadLocal.USUARIO,
                PWD: payLoadLocal.PWD,
                RAZON: Seleccionado.Razon,
                DIRECCION: "",
                POBLACION: Seleccionado.Poblacion,
                PROVINCIA: "",
                CODIGO_POSTAL: "",
                PAIS: "",
                TELEFONO: Seleccionado.Telefono,
                MAIL: "",
                CIF_TALLER: Seleccionado.Cif,
                ID_SOCIO: payLoadLocal.ID_SOCIO,
                EMPRESA_SOCIO: payLoadLocal.EMPRESA_SOCIO,
                CLIENTE: Seleccionado.Codigo,
                CENTRO: payLoadLocal.CENTRO,
                ALMACEN: payLoadLocal.ALMACEN,
                SOLO_CATALOGO: payLoadLocal.SOLO_CATALOGO,
                FILTRAR_MARCAS: payLoadLocal.FILTRAR_MARCAS,
                VER_SOLO_REFERENCIAS_MARCAS_SOCIO: payLoadLocal.VER_SOLO_REFERENCIAS_MARCAS_SOCIO,
                SIEMPRE_VERDE: payLoadLocal.SIEMPRE_VERDE,
                PERMISO_MATRICULAS: payLoadLocal.PERMISO_MATRICULAS,
                PERMISO_NEUMATICOS: payLoadLocal.PERMISO_NEUMATICOS,
                PERMISO_MOTOS:payLoadLocal.PERMISO_MOTOS,
                DEFECTO: payLoadLocal.DEFECTO,
                MAXIMO_MATRICULAS_MENSUAL: payLoadLocal.MAXIMO_MATRICULAS_MENSUAL,
                PLANTILLA: payLoadLocal.PLANTILLA,
                SEMAFORO_DISPONIBILIDAD: payLoadLocal.SEMAFORO_DISPONIBILIDAD,
                DESCRIPCION: payLoadLocal.DESCRIPCION,
                ID_IDIOMA: payLoadLocal.ID_IDIOMA,
                CORREO_RECUPERACION_PWD: payLoadLocal.CORREO_RECUPERACION_PWD,
                OBSERVACIONES: payLoadLocal.OBSERVACIONES,
                VISUALIZAR_PVP: payLoadLocal.VISUALIZAR_PVP,
                VISUALIZAR_ADICIONALES: payLoadLocal.VISUALIZAR_ADICIONALES,
                PERMISO_PRESUPUESTOS_GTESTIMATE: payLoadLocal.PERMISO_PRESUPUESTOS_GTESTIMATE,
                MAXIMO_PRESUPUESTOS_GTESTIMATE: payLoadLocal.MAXIMO_PRESUPUESTOS_GTESTIMATE,
                MAXIMO_CATALOGO_ORIGINAL: payLoadLocal.MAXIMO_CATALOGO_ORIGINAL,
                PERMISO_CATALOGO_ORIGINAL: payLoadLocal.PERMISO_CATALOGO_ORIGINAL,
                PERMISO_LUBRICANTES: payLoadLocal.PERMISO_LUBRICANTES,
                PERMISO_BATERIAS: payLoadLocal.PERMISO_BATERIAS,
                ABRIR_SIEMPRE_DESGLOSE_COMPRAR: payLoadLocal.ABRIR_SIEMPRE_DESGLOSE_COMPRAR,
                CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA: payLoadLocal.CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA,
                FACTURACION_LITE: payLoadLocal.FACTURACION_LITE,
                MOSTRAR_BOTON_POR_DEFECTO: payLoadLocal.MOSTRAR_BOTON_POR_DEFECTO,
                ID_PAIS: payLoadLocal.ID_PAIS,
                PERMISO_DOCUMENTACION_TECNICA: payLoadLocal.PERMISO_DOCUMENTACION_TECNICA,




                PERMISO_BASTIDORES: payLoadLocal.PERMISO_BASTIDORES,
                MAXIMO_BASTIDORES_MENSUAL: payLoadLocal.MAXIMO_BASTIDORES_MENSUAL,
                ID_TIPO_CLIENTE: payLoadLocal.ID_TIPO_CLIENTE,
                COMPRAR_SIN_DISPONIBILIDAD: payLoadLocal.COMPRAR_SIN_DISPONIBILIDAD,
                ID_MONEDA: payLoadLocal.ID_MONEDA,

                ID_TIENDA_RETAIL: payLoadLocal.ID_TIENDA_RETAIL,
                CODIGO_CLIENTE_TIENDA: payLoadLocal.CODIGO_CLIENTE_TIENDA,


                CREAR_NEXT_DATA_BASIC: payLoadLocal.CREAR_NEXT_DATA_BASIC,
                ORIGEN_NEXTDATA_BASIC: payLoadLocal.ORIGEN_NEXTDATA_BASIC,
                BAJA_NEXT_DATA_BASIC: payLoadLocal.BAJA_NEXT_DATA_BASIC,
                CAMBIAR_ORIGEN_NEXT_DATA_BASIC:payLoadLocal.CAMBIAR_ORIGEN_NEXT_DATA_BASIC,

                CREAR_NEXT_DATA_MANUALES: payLoadLocal.CREAR_NEXT_DATA_MANUALES,
                ORIGEN_NEXTDATA_MANUALES: payLoadLocal.ORIGEN_NEXTDATA_MANUALES,
                BAJA_NEXT_DATA_MANUALES:payLoadLocal.BAJA_NEXT_DATA_MANUALES,
    
                CREAR_NEXT_DATA_COMPLETO: payLoadLocal.CREAR_NEXT_DATA_COMPLETO,
                ORIGEN_NEXTDATA_COMPLETO: payLoadLocal.ORIGEN_NEXTDATA_COMPLETO,
                USUARIO_NEXTDATA_COMPLETO: payLoadLocal.USUARIO_NEXTDATA_COMPLETO,
                PWD_NEXTDATA_COMPLETO: payLoadLocal.PWD_NEXTDATA_COMPLETO,
                BAJA_NEXT_DATA_COMPLETO: payLoadLocal.BAJA_NEXT_DATA_COMPLETO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const ModificarLicenciaClienteEnAPI = (payLoadLocal, ID_USUARIO, ID) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/UsuarioSertec/ModificarLicenciaCliente', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID: ID,
                ID_USUARIO: ID_USUARIO,
                USUARIO: payLoadLocal.USUARIO,
                PWD: payLoadLocal.PWD,
                DESCRIPCION: payLoadLocal.DESCRIPCION,
                ID_IDIOMA: payLoadLocal.ID_IDIOMA,
                CORREO_RECUPERACION_PWD: payLoadLocal.CORREO_RECUPERACION_PWD,
                OBSERVACIONES: payLoadLocal.OBSERVACIONES,
                EMPRESA_SOCIO: payLoadLocal.EMPRESA_SOCIO,
                ALMACEN: payLoadLocal.ALMACEN,
                CENTRO: payLoadLocal.CENTRO,
                DEFECTO: payLoadLocal.DEFECTO,
                SOLO_CATALOGO: payLoadLocal.SOLO_CATALOGO,
                FILTRAR_MARCAS: payLoadLocal.FILTRAR_MARCAS,
                VER_SOLO_REFERENCIAS_MARCAS_SOCIO: payLoadLocal.VER_SOLO_REFERENCIAS_MARCAS_SOCIO,
                SIEMPRE_VERDE: payLoadLocal.SIEMPRE_VERDE,
                SEMAFORO_DISPONIBILIDAD: payLoadLocal.SEMAFORO_DISPONIBILIDAD,
                PERMISO_MATRICULAS: payLoadLocal.PERMISO_MATRICULAS,
                PERMISO_NEUMATICOS: payLoadLocal.PERMISO_NEUMATICOS,
                PERMISO_MOTOS:payLoadLocal.PERMISO_MOTOS,
                MAXIMO_MATRICULAS_MENSUAL: payLoadLocal.MAXIMO_MATRICULAS_MENSUAL,
                PLANTILLA: payLoadLocal.PLANTILLA,
                VISUALIZAR_PVP: payLoadLocal.VISUALIZAR_PVP,
                VISUALIZAR_ADICIONALES: payLoadLocal.VISUALIZAR_ADICIONALES,
                PERMISO_PRESUPUESTOS_GTESTIMATE: payLoadLocal.PERMISO_PRESUPUESTOS_GTESTIMATE,
                MAXIMO_PRESUPUESTOS_GTESTIMATE: payLoadLocal.MAXIMO_PRESUPUESTOS_GTESTIMATE,
                MAXIMO_CATALOGO_ORIGINAL: payLoadLocal.MAXIMO_CATALOGO_ORIGINAL,
                PERMISO_CATALOGO_ORIGINAL: payLoadLocal.PERMISO_CATALOGO_ORIGINAL,
                PERMISO_LUBRICANTES: payLoadLocal.PERMISO_LUBRICANTES,
                PERMISO_BATERIAS: payLoadLocal.PERMISO_BATERIAS,
                ABRIR_SIEMPRE_DESGLOSE_COMPRAR: payLoadLocal.ABRIR_SIEMPRE_DESGLOSE_COMPRAR,
                CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA: payLoadLocal.CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA,
                FACTURACION_LITE: payLoadLocal.FACTURACION_LITE,
                MOSTRAR_BOTON_POR_DEFECTO: payLoadLocal.MOSTRAR_BOTON_POR_DEFECTO,
                ID_PAIS: payLoadLocal.ID_PAIS,
                PERMISO_DOCUMENTACION_TECNICA: payLoadLocal.PERMISO_DOCUMENTACION_TECNICA,





                PERMISO_BASTIDORES: payLoadLocal.PERMISO_BASTIDORES,
                MAXIMO_BASTIDORES_MENSUAL: payLoadLocal.MAXIMO_BASTIDORES_MENSUAL,
                ID_TIPO_CLIENTE: payLoadLocal.ID_TIPO_CLIENTE,
                COMPRAR_SIN_DISPONIBILIDAD: payLoadLocal.COMPRAR_SIN_DISPONIBILIDAD,
                ID_MONEDA: payLoadLocal.ID_MONEDA,
                ID_TIENDA_RETAIL: payLoadLocal.ID_TIENDA_RETAIL,


                
                CREAR_NEXT_DATA_BASIC: payLoadLocal.CREAR_NEXT_DATA_BASIC,
                ORIGEN_NEXTDATA_BASIC: payLoadLocal.ORIGEN_NEXTDATA_BASIC,
                BAJA_NEXT_DATA_BASIC: payLoadLocal.BAJA_NEXT_DATA_BASIC,
                CAMBIAR_ORIGEN_NEXT_DATA_BASIC:payLoadLocal.CAMBIAR_ORIGEN_NEXT_DATA_BASIC,


                CREAR_NEXT_DATA_MANUALES: payLoadLocal.CREAR_NEXT_DATA_MANUALES,
                ORIGEN_NEXTDATA_MANUALES: payLoadLocal.ORIGEN_NEXTDATA_MANUALES,
                BAJA_NEXT_DATA_MANUALES:payLoadLocal.BAJA_NEXT_DATA_MANUALES,
    
                CREAR_NEXT_DATA_COMPLETO: payLoadLocal.CREAR_NEXT_DATA_COMPLETO,
                ORIGEN_NEXTDATA_COMPLETO: payLoadLocal.ORIGEN_NEXTDATA_COMPLETO,
                USUARIO_NEXTDATA_COMPLETO: payLoadLocal.USUARIO_NEXTDATA_COMPLETO,
                PWD_NEXTDATA_COMPLETO: payLoadLocal.PWD_NEXTDATA_COMPLETO,
                BAJA_NEXT_DATA_COMPLETO:payLoadLocal.BAJA_NEXT_DATA_COMPLETO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const CrearLicenciaMostradorEnAPI = (payLoadLocal) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/UsuarioSertec/CrearLicenciaMostrador', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                USUARIO: payLoadLocal.USUARIO,
                PWD: payLoadLocal.PWD,
                DESCRIPCION: payLoadLocal.DESCRIPCION,
                ID_SOCIO: payLoadLocal.ID_SOCIO,
                ID_IDIOMA: payLoadLocal.ID_IDIOMA,
                CORREO_RECUPERACION_PWD: payLoadLocal.CORREO_RECUPERACION_PWD,
                OBSERVACIONES: payLoadLocal.OBSERVACIONES,
                EMPRESA_SOCIO: payLoadLocal.EMPRESA_SOCIO,
                ALMACEN: payLoadLocal.ALMACEN,
                SOLO_CATALOGO: payLoadLocal.SOLO_CATALOGO,
                FILTRAR_MARCAS: payLoadLocal.FILTRAR_MARCAS,
                VER_SOLO_REFERENCIAS_MARCAS_SOCIO: payLoadLocal.VER_SOLO_REFERENCIAS_MARCAS_SOCIO,
                SIEMPRE_VERDE: payLoadLocal.SIEMPRE_VERDE,
                SEMAFORO_DISPONIBILIDAD: payLoadLocal.SEMAFORO_DISPONIBILIDAD,
                PERMISO_MATRICULAS: payLoadLocal.PERMISO_MATRICULAS,
                PERMISO_NEUMATICOS: payLoadLocal.PERMISO_NEUMATICOS,
                PERMISO_MOTOS:payLoadLocal.PERMISO_MOTOS,
                MAXIMO_MATRICULAS_MENSUAL: payLoadLocal.MAXIMO_MATRICULAS_MENSUAL,
                PLANTILLA: payLoadLocal.PLANTILLA,
                VISUALIZAR_PVP: payLoadLocal.VISUALIZAR_PVP,
                VISUALIZAR_ADICIONALES: payLoadLocal.VISUALIZAR_ADICIONALES,
                PERMISO_PRESUPUESTOS_GTESTIMATE: payLoadLocal.PERMISO_PRESUPUESTOS_GTESTIMATE,
                MAXIMO_PRESUPUESTOS_GTESTIMATE: payLoadLocal.MAXIMO_PRESUPUESTOS_GTESTIMATE,
                MAXIMO_CATALOGO_ORIGINAL: payLoadLocal.MAXIMO_CATALOGO_ORIGINAL,
                PERMISO_CATALOGO_ORIGINAL: payLoadLocal.PERMISO_CATALOGO_ORIGINAL,
                PERMISO_LUBRICANTES: payLoadLocal.PERMISO_LUBRICANTES,
                PERMISO_BATERIAS: payLoadLocal.PERMISO_BATERIAS,
                ABRIR_SIEMPRE_DESGLOSE_COMPRAR: payLoadLocal.ABRIR_SIEMPRE_DESGLOSE_COMPRAR,
                CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA: payLoadLocal.CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA,
                MOSTRAR_BOTON_POR_DEFECTO: payLoadLocal.MOSTRAR_BOTON_POR_DEFECTO,
                ID_PAIS: payLoadLocal.ID_PAIS,
                PERMISO_DOCUMENTACION_TECNICA: payLoadLocal.PERMISO_DOCUMENTACION_TECNICA,
                VISUALIZAR_STOCKS_REMOTOS_GRUPO: payLoadLocal.VISUALIZAR_STOCKS_REMOTOS_GRUPO,
                CAMBIAR_ORIGEN_NEXT_DATA_BASIC:payLoadLocal.CAMBIAR_ORIGEN_NEXT_DATA_BASIC,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const ModificarLicenciaMostradorEnAPI = (payLoadLocal, ID_USUARIO, ID) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/UsuarioSertec/ModificarLicenciaMostrador', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID: ID,
                ID_USUARIO: ID_USUARIO,
                USUARIO: payLoadLocal.USUARIO,
                PWD: payLoadLocal.PWD,
                DESCRIPCION: payLoadLocal.DESCRIPCION,
                ID_SOCIO: payLoadLocal.ID_SOCIO,
                ID_IDIOMA: payLoadLocal.ID_IDIOMA,
                CORREO_RECUPERACION_PWD: payLoadLocal.CORREO_RECUPERACION_PWD,
                OBSERVACIONES: payLoadLocal.OBSERVACIONES,
                EMPRESA_SOCIO: payLoadLocal.EMPRESA_SOCIO,
                ALMACEN: payLoadLocal.ALMACEN,
                SOLO_CATALOGO: payLoadLocal.SOLO_CATALOGO,
                FILTRAR_MARCAS: payLoadLocal.FILTRAR_MARCAS,
                SIEMPRE_VERDE: payLoadLocal.SIEMPRE_VERDE,
                SEMAFORO_DISPONIBILIDAD: payLoadLocal.SEMAFORO_DISPONIBILIDAD,
                VER_SOLO_REFERENCIAS_MARCAS_SOCIO: payLoadLocal.VER_SOLO_REFERENCIAS_MARCAS_SOCIO,
                PERMISO_MATRICULAS: payLoadLocal.PERMISO_MATRICULAS,
                PERMISO_NEUMATICOS: payLoadLocal.PERMISO_NEUMATICOS,
                PERMISO_MOTOS:payLoadLocal.PERMISO_MOTOS,
                MAXIMO_MATRICULAS_MENSUAL: payLoadLocal.MAXIMO_MATRICULAS_MENSUAL,
                PLANTILLA: payLoadLocal.PLANTILLA,
                VISUALIZAR_PVP: payLoadLocal.VISUALIZAR_PVP,
                VISUALIZAR_ADICIONALES: payLoadLocal.VISUALIZAR_ADICIONALES,
                PERMISO_PRESUPUESTOS_GTESTIMATE: payLoadLocal.PERMISO_PRESUPUESTOS_GTESTIMATE,
                MAXIMO_PRESUPUESTOS_GTESTIMATE: payLoadLocal.MAXIMO_PRESUPUESTOS_GTESTIMATE,
                MAXIMO_CATALOGO_ORIGINAL: payLoadLocal.MAXIMO_CATALOGO_ORIGINAL,
                PERMISO_CATALOGO_ORIGINAL: payLoadLocal.PERMISO_CATALOGO_ORIGINAL,
                PERMISO_LUBRICANTES: payLoadLocal.PERMISO_LUBRICANTES,
                PERMISO_BATERIAS: payLoadLocal.PERMISO_BATERIAS,
                ABRIR_SIEMPRE_DESGLOSE_COMPRAR: payLoadLocal.ABRIR_SIEMPRE_DESGLOSE_COMPRAR,
                CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA: payLoadLocal.CESTA_AUTOMATICA_DISPONIBILIDAD_NARANJA,
                MOSTRAR_BOTON_POR_DEFECTO: payLoadLocal.MOSTRAR_BOTON_POR_DEFECTO,
                ID_PAIS: payLoadLocal.ID_PAIS,
                PERMISO_DOCUMENTACION_TECNICA: payLoadLocal.PERMISO_DOCUMENTACION_TECNICA,
                VISUALIZAR_STOCKS_REMOTOS_GRUPO: payLoadLocal.VISUALIZAR_STOCKS_REMOTOS_GRUPO,
                CAMBIAR_ORIGEN_NEXT_DATA_BASIC:payLoadLocal.CAMBIAR_ORIGEN_NEXT_DATA_BASIC,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetCSVEnAPI = (REGISTROS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Estadisticas/GetCSV', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGISTROS: REGISTROS,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetListaHTMLEnAPI = (REGISTROS, TITULO, SUBTITULO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Estadisticas/GetListaHTML', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGISTROS: REGISTROS,
                TITULO: TITULO,
                SUBTITULO: SUBTITULO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetListaPDFEnAPI = (REGISTROS, TITULO, SUBTITULO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Estadisticas/GetListaPDF', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGISTROS: REGISTROS,
                TITULO: TITULO,
                SUBTITULO: SUBTITULO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const ObtenerLicenciasSertecFacturacionEnAPI = (MES, ANYO, ID_SOCIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Estadisticas/ObtenerLicenciasSertecFacturacion', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                MES: MES,
                ANYO: ANYO,
                ID_SOCIO: ID_SOCIO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const ObtenerLicenciasSertecFacturacionDesgloseEnAPI = (MES, ANYO, ID_SOCIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Estadisticas/ObtenerLicenciasSertecFacturacionDesglose', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            MES: MES,
            ANYO: ANYO,
            ID_SOCIO: ID_SOCIO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetEstadisticasTotalesEnAPI = (FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA, SOCIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Matricula/GetEstadisticasTotales', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                FECHA_PARTIDA: FECHA_PARTIDA,
                ACCION_DESDE: ACCION_DESDE,
                ACCION_HASTA: ACCION_HASTA,
                PLATAFORMA: "SERTEC",
                ID_SOCIO: SOCIO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const ObtenerHistoricoTarifasEnAPI = (REGSPAGE,PAGE,ORDERCOLUM,ORDERDIR,ID, ID_PROVEEDOR,ID_MARCA,FECHA_PARTIDA,ADMINISTRADOR,ACCION_DESDE,ACCION_HASTA,ACCION_ULTIMAS,ACCION_FUTURAS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/ObtenerHistoricoTarifas', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: REGSPAGE,
            PAGE: PAGE,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID:ID,
            ID_PROVEEDOR: ID_PROVEEDOR,
            ID_MARCA:ID_MARCA,
            FECHA_PARTIDA:FECHA_PARTIDA,
            ADMINISTRADOR:ADMINISTRADOR,
            ACCION_DESDE:ACCION_DESDE,
            ACCION_HASTA:ACCION_HASTA,
            ACCION_ULTIMAS:ACCION_ULTIMAS,
            ACCION_FUTURAS:ACCION_FUTURAS,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetMarcaProveedorEnAPI = (ID_PROVEEDOR) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/GetMarcaProveedor', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_PROVEEDOR: ID_PROVEEDOR,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const CrearLicenciaUsuarioNextAssistEnAPI = (PAYLOAD) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/CrearLicenciaUsuarioNextAssist', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            USUARIO: PAYLOAD.USUARIO,
            PWD: PAYLOAD.PWD,
            CIF_TALLER: PAYLOAD.CIF_TALLER,
            RAZON: PAYLOAD.RAZON,
            DIRECCION: PAYLOAD.DIRECCION,
            CODIGO_POSTAL: PAYLOAD.CODIGO_POSTAL,
            POBLACION: PAYLOAD.POBLACION,
            PROVINCIA: PAYLOAD.PROVINCIA,
            PAIS: PAYLOAD.PAIS,
            MAIL: PAYLOAD.MAIL,
            TELEFONO: PAYLOAD.TELEFONO,
            ID_SOCIO: PAYLOAD.ID_SOCIO,
            EMPRESA_SOCIO: PAYLOAD.EMPRESA_SOCIO,
            ID_IDIOMA: PAYLOAD.ID_IDIOMA,
            CORREO_RECUPERACION_PWD: PAYLOAD.CORREO_RECUPERACION_PWD,
            OBSERVACIONES: PAYLOAD.OBSERVACIONES,
            ID_DEPARTAMENTO: PAYLOAD.ID_DEPARTAMENTO,
            DISENYO_ESPECIAL: PAYLOAD.DISENYO_ESPECIAL,
            PROHIBIR_CONSULTAS:PAYLOAD.PROHIBIR_CONSULTAS,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const DarBajaUsuarioNextAssistEnAPI = (ID_USUARIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/DarBajaUsuarioNextAssist', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_USUARIO: ID_USUARIO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const EnviarCredencialesUsuarioTallerEnAPI = (ID_USUARIO) => {


    controller = new AbortController();
    return fetch(endpointBackOffice + "api/NextAssist/EnviarCredencialesUsuarioTaller", {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_USUARIO: ID_USUARIO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                    return res;
                } else {
                    return res;
                }
            }
        })
}




const EnviarMailBienvenidaEnAPI = (ID_USUARIO,ID_SOCIO) => {


    controller = new AbortController();
    return fetch(endpointBackOffice + "api/NextAssist/EnviarMensajeBienvenidaTaller", {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_USUARIO: ID_USUARIO,
                ID_SOCIO:ID_SOCIO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                    return res;
                } else {
                    return res;
                }
            }
        })
}



const GetLicenciasFacturacionDesgloseEnAPI = (MES, ANYO, ID_SOCIO, ID_DEPARTAMENTO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetLicenciasFacturacionDesglose', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            MES: MES,
            ANYO: ANYO,
            ID_SOCIO: ID_SOCIO,
            ID_DEPARTAMENTO: ID_DEPARTAMENTO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetLicenciasFacturacionDesgloseTareaHtmlEnAPI = (ID_TAREA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetLicenciasFacturacionDesgloseTareaHtml', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_TAREA: ID_TAREA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetLicenciasFacturacionDesgloseTareasEnAPI = (MES, ANYO, ID_TALLER) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetLicenciasFacturacionDesgloseTareas', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            MES: MES,
            ANYO: ANYO,
            ID_TALLER: ID_TALLER,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetUsuariosNextAssistEnAPI = (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID_SOCIO, ID, ID_TALLER, USUARIO, RAZON_SOCIO, NOMBRE_TALLER, BAJA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetUsuariosNextAssist', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: REGSPAGE,
            PAGE: PAGE,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            ID_TALLER: ID_TALLER,
            ID_SOCIO: ID_SOCIO,
            USUARIO: USUARIO,
            RAZON_SOCIO: RAZON_SOCIO,
            NOMBRE_TALLER: NOMBRE_TALLER,
            BAJA: BAJA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const NextAssistgetLicenciasFacturacionEnAPI = (MES, ANYO, ID_SOCIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetLicenciasFacturacion', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            MES: MES,
            ANYO: ANYO,
            ID_SOCIO: ID_SOCIO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const SetUsuariosNextAssistEnAPI = (ACCION, PAYLOAD) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/SetUsuariosNextAssist', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: PAYLOAD.ID,
            USUARIO: PAYLOAD.USUARIO,
            PWD: PAYLOAD.PWD,
            ID_TALLER: PAYLOAD.ID_TALLER,
            ID_SOCIO: PAYLOAD.ID_SOCIO,
            ID_IDIOMA: PAYLOAD.ID_IDIOMA,
            BAJA: PAYLOAD.BAJA,
            CORREO_RECUPERACION_PWD: PAYLOAD.CORREO_RECUPERACION_PWD,
            OBSERVACIONES: PAYLOAD.OBSERVACIONES,
            ID_DEPARTAMENTO: PAYLOAD.ID_DEPARTAMENTO,
            DISENYO_ESPECIAL: PAYLOAD.DISENYO_ESPECIAL,
            PROHIBIR_CONSULTAS:PAYLOAD.PROHIBIR_CONSULTAS,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const GetClientesERPSocioEnAPI = (id, ORDERCOLUM, ORDERDIR, ID_SOCIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + "api/Socio/GetClientesERPSocio", {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGSPAGE: 10000,
                PAGE: 1,
                ORDERCOLUM: ORDERCOLUM,
                ORDERDIR: ORDERDIR,
                ID_SOCIO: ID_SOCIO,
                ID: id,
                CODIGO: "",
                NOMBRE: "",
                CIF: "",
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                    return res;
                } else {
                    return res;
                }
            }
        })
}



const SetClientesERPSocioEnAPI = (ACCION, datosCliente) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + "api/Socio/SetClientesERPSocio", {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ACCION: ACCION,
                ID: datosCliente.id,
                ID_SOCIO: datosCliente.idSocio,
                CODIGO: datosCliente.codigo,
                NOMBRE: datosCliente.nombre,
                CIF: datosCliente.cif,
                DIRECCION: datosCliente.direccion,
                POBLACION: datosCliente.poblacion,
                PROVINCIA: datosCliente.provincia,
                CP: datosCliente.cp,
                TELEFONO: datosCliente.telefono1,
                MAIL: datosCliente.email,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                    return res;
                } else {
                    return res;
                }
            }
        })
}


const GetEjerciciosCSVEnAPI = (REGISTROS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetEjerciciosCSV', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGISTROS: REGISTROS,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetEstadisticasAnyosEnAPI = (ID_RED) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetEstadisticasAnyos', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_RED: ID_RED,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetEstadisticasEnAPI = (ID_SOCIO, MES, ANYO, ID_DEPARTAMENTO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetEstadisticas', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_SOCIO: ID_SOCIO,
            MES: MES,
            ANYO: ANYO,
            ID_DEPARTAMENTO: ID_DEPARTAMENTO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetEstadisticasEvolucionEnAPI = (ID_SOCIO, ID_DEPARTAMENTO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetEstadisticasEvolucion', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_SOCIO: ID_SOCIO,
            ID_DEPARTAMENTO: ID_DEPARTAMENTO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetEstadisticasRankingEnAPI = (ID_SOCIO, MES, ANYO, ID_DEPARTAMENTO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetEstadisticasRanking', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_SOCIO: ID_SOCIO,
            MES: MES,
            ANYO: ANYO,
            ID_DEPARTAMENTO: ID_DEPARTAMENTO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetEstadisticasNextAssistTecnicoNivelEnAPI = (ID_SOCIO, MES, ANYO, ID_DEPARTAMENTO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetEstadisticasNextAssistTecnicoNivel', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_SOCIO: ID_SOCIO,
            MES: MES,
            ANYO: ANYO,
            ID_DEPARTAMENTO: ID_DEPARTAMENTO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetEstadisticasTecnicoEnAPI = (ID_SOCIO, MES, ANYO, ID_DEPARTAMENTO, DIA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetEstadisticasTecnico', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_SOCIO: ID_SOCIO,
            MES: MES,
            ANYO: ANYO,
            ID_DEPARTAMENTO: ID_DEPARTAMENTO,
            DIA:DIA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetEstadisticasTecnicoTareasEnAPI = (DIA,MES, ANYO,ID_USUARIO_TECNICO,ID_SOCIO,ID_DEPARTAMENTO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetEstadisticasTecnicoTareas', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            MES: MES,
            ANYO: ANYO,
            DIA:DIA,
            ID_USUARIO_TECNICO :ID_USUARIO_TECNICO,
            ID_SOCIO:ID_SOCIO,
            ID_DEPARTAMENTO:ID_DEPARTAMENTO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetFamiliaCSVEnAPI = (REGISTROS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetFamiliaCSV', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGISTROS: REGISTROS,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const GetMarcasCSVEnAPI = (REGISTROS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetMarcasCSV', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGISTROS: REGISTROS,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const GetTiposTareaCSVEnAPI = (REGISTROS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetTiposTareaCSV', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGISTROS: REGISTROS,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const ObtenerEstadisticasCentrosTalleresRedEnAPI = (TOP, ID_RED, TIPO_RED, MES, ANYO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Redes/ObtenerEstadisticasCentrosTalleresRed', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                TOP: TOP,
                ID_RED: ID_RED,
                TIPO_RED: TIPO_RED,
                MES: MES,
                ANYO: ANYO,

                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const ObtenerEstadisticasProveedoresRedTalleresEnAPI = (TOP, ID_RED, TIPO_RED, MES, ANYO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Redes/ObtenerEstadisticasProveedoresRedTalleres', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                TOP: TOP,
                ID_RED: ID_RED,
                TIPO_RED: TIPO_RED,
                MES: MES,
                ANYO: ANYO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


const ModificarReglasAlmacenesAlternativosSocioEnAPI = (ACCION, PAYLOAD) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/UsuarioSertec/ModificarReglasAlmacenesAlternativosSocio', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ACCION: ACCION,
                ID: PAYLOAD.ID,
                ID_SOCIO: PAYLOAD.ID_SOCIO,
                ALMACEN: PAYLOAD.ALMACEN,
                ALMACEN_ALTERNATIVO: PAYLOAD.ALMACEN_ALTERNATIVO,
                REPETICION: PAYLOAD.REPETICION,
                DIA_REPETICION: PAYLOAD.DIA_REPETICION,
                FECHA_UNICA: PAYLOAD.FECHA_UNICA,
                OBSERVACIONES: PAYLOAD.OBSERVACIONES,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const ObtenerReglasAlmacenesAlternativosSocioEnAPI = (ORDERCOLUM, ORDERDIR, ID_SOCIO, ID, ALMACEN) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/UsuarioSertec/ObtenerReglasAlmacenesAlternativosSocio', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGSPAGE: 1000,
                PAGE: 1,
                ORDERCOLUM: ORDERCOLUM,
                ORDERDIR: ORDERDIR,
                ID_SOCIO: ID_SOCIO,
                ID: ID,
                ALMACEN: ALMACEN,
                MENSAJE_ERROR: "",
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const ActualizarReglasMarcasGruposMontajeEnAPI = (ACCION, ID, ID_SOCIO, ID_MARCA, MARCA_DESCRIPCION, LINEAS_GM) => {
    controller = new AbortController();

    return fetch(endpointBackOffice + 'api/Marcas/ActualizarReglasMarcasGruposMontaje', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ACCION: ACCION,
                ID: ID,
                ID_SOCIO: ID_SOCIO,
                ID_MARCA: ID_MARCA,
                MARCA_DESCRIPCION: MARCA_DESCRIPCION,
                LINEAS_GM: LINEAS_GM,


                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const ObtenerReglasMarcasGruposMontajeEnAPI = (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID_SOCIO, ID, MARCA, GRUPO_MOTAJE) => {
    controller = new AbortController();

    return fetch(endpointBackOffice + 'api/Marcas/ObtenerReglasMarcasGruposMontaje', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGSPAGE: REGSPAGE,
                PAGE: PAGE,
                ORDERCOLUM: ORDERCOLUM,
                ORDERDIR: ORDERDIR,
                ID_SOCIO: ID_SOCIO,
                ID: ID,
                MARCA: MARCA,
                GRUPO_MOTAJE: GRUPO_MOTAJE,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const ActualizarReglasNeumaticosMarcasEnAPI = (ACCION, ID_SOCIO, ID_MARCA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Marcas/ActualizarReglasNeumaticosMarcas', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ACCION: ACCION,
                ID_SOCIO: ID_SOCIO,
                ID_MARCA: ID_MARCA,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




const ObtenerNeumaticosMarcasEnAPI = (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID, DESCRIPCION, ID_SOCIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Marcas/ObtenerNeumaticosMarcas', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGSPAGE: REGSPAGE,
                PAGE: PAGE,
                ORDERCOLUM: ORDERCOLUM,
                ORDERDIR: ORDERDIR,
                ID: ID,
                DESCRIPCION: DESCRIPCION,
                ID_SOCIO: ID_SOCIO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}





const ObtenerFiltrosEstadisticasConsumosEnAPI = () => {
    controller = new AbortController();
    return fetch(`${endpointBackOffice}api/NextGroup/ObtenerFiltrosEstadisticasConsumos/${window.btoa(obtenerToken())}`, {
        method: 'GET',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



export const ObtenerConsumosEnAPI = ( FILTRO1, FILTRO2,ACCION_DESDE,ACCION_HASTA,ANYO,PAIS,ID_SOCIO,DESCARGAR_CSV,signal) => {
   // controller = new AbortController();

    return fetch(endpointBackOffice + 'api/NextGroup/Consumos/Estadisticas', {
        method: 'POST',
        signal: signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
      
                FILTRO1: FILTRO1,
                FILTRO2: FILTRO2,
                MES_INI:ACCION_DESDE,
                MES_FIN:ACCION_HASTA,
                ANYO:ANYO,
                ID_PAIS:PAIS,
                ID_SOCIO:ID_SOCIO,
                DESCARGAR_CSV:DESCARGAR_CSV,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}





export const EstadisticasConsumosTotalesEnAPI = (ANYO,PAIS,ID_SOCIO,ACCION_DESDE, ACCION_HASTA,signal) => {
   // controller = new AbortController();

    return fetch(endpointBackOffice + 'api/NextGroup/Consumos/EstadisticasConsumosTotales', {
        method: 'POST',
        signal: signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ANYO:ANYO,
                ID_PAIS:PAIS,
                ID_SOCIO:ID_SOCIO,
                MES_INI:ACCION_DESDE,
                MES_FIN:ACCION_HASTA,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



export const DashboardHomeEnAPI = ( MES_INI, MES_FIN,ANYO,CONSULTA,ID_SOCIO,ID_PAIS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/Dashboard', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
      
                MES_INI: MES_INI,
                MES_FIN: MES_FIN,
                ANYO:ANYO,
                CONSULTA:CONSULTA,
                ID_SOCIO:ID_SOCIO,
                ID_PAIS:ID_PAIS,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



export const ObtenerTiposClientesEnAPI = (ID, ID_SOCIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Socio/ObtenerTiposClientes', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID: ID,
            ID_SOCIO: ID_SOCIO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




export const ActualizarLicenciaNextDataSertecEnAPI = (ACCION, PAYLOAD_DATA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextData/ActualizarLicenciaNextDataSertec', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID_USUARIO_SERTEC: PAYLOAD_DATA.ID_USUARIO_SERTEC,
            ID_PROGRAMA: PAYLOAD_DATA.ID_PROGRAMA,
            ID_VERSION: PAYLOAD_DATA.ID_VERSION,
            FECHA_ALTA: PAYLOAD_DATA.FECHA_ALTA,
            USUARIO: PAYLOAD_DATA.USUARIO,
            CONTRASEÑA: PAYLOAD_DATA.CONTRASEÑA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



export const ProgramasEnAPI = (ACCION, PAYLOAD_DATA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextData/Programas', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



export const ReactivarLicenciaEnAPI = (ID_USUARIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/UsuarioSertec/ReactivarLicencia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_USUARIO:ID_USUARIO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



export const HistorialUsuarioEnAPI = (ID_USUARIO_SERTEC) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextData/HistorialUsuario', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_USUARIO_SERTEC:ID_USUARIO_SERTEC,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




export const GetMonedasEnAPI = (ORDERCOLUM, ORDERDIR, ID, NOMBRE) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Pais/GetMonedas', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 1000,
            PAGE: 1,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            NOMBRE: NOMBRE,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




export const SetMonedaEnAPI = (ACCION, ID, SIMBOLO, NOMBRE) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Pais/SetMoneda', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: ID,
            SIMBOLO: SIMBOLO,
            NOMBRE: NOMBRE,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




export const ActualizarTiposClientesEnAPI = (ACCION, ID, ID_SOCIO, DESCRIPCION) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Socio/ActualizarTiposClientes', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: ID,
            ID_SOCIO: ID_SOCIO,
            DESCRIPCION: DESCRIPCION,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




export const ObtenerClientesTiendasEnAPI = (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID, ID_SOCIO, CODIGO_CLIENTE_SOCIO, NOMBRE) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Socio/ObtenerClientesTiendas', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: REGSPAGE,
            PAGE: PAGE,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID_SOCIO: ID_SOCIO,
            ID: ID,
            CODIGO_CLIENTE_SOCIO: CODIGO_CLIENTE_SOCIO,
            NOMBRE: NOMBRE,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



export const ActualizarClientesTiendaEnAPI = (ACCION, PAYLOAD) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Socio/ActualizarClientesTienda', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: PAYLOAD.ID,
            ID_SOCIO: PAYLOAD.ID_SOCIO,
            CODIGO_CLIENTE_SOCIO: PAYLOAD.CODIGO_CLIENTE_SOCIO,
            NOMBRE: PAYLOAD.NOMBRE,
            ID_TIPO_TIENDA: PAYLOAD.ID_TIPO_INTEGRACION,
            TANTO_PORCIENTO_INCREMENTO: PAYLOAD.TANTO_PORCIENTO_INCREMENTO,
            CORREO_RECEPCION_PEDIDOS: PAYLOAD.CORREO_RECEPCION_PEDIDOS,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}





export const ObtenerClientesTiendasTipoIntegracionEnAPI = (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID, DESCRIPCION) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Socio/ObtenerClientesTiendasTipoIntegracion', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: REGSPAGE,
            PAGE: PAGE,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            DESCRIPCION: DESCRIPCION,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




export const HistorialUsuarioLiteEnAPI = (ID_USUARIO_SERTEC) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextControl/Lite/HistorialUsuario', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_USUARIO_SERTEC:ID_USUARIO_SERTEC,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




export const GetEstadisticasEvolucionMesDetalleEnAPI = (ID_SOCIO, ID_DEPARTAMENTO, DIA, MES, ANYO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetEstadisticasEvolucionMesDetalle', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_SOCIO: ID_SOCIO,
            ID_DEPARTAMENTO: ID_DEPARTAMENTO,
            DIA: DIA,
            MES: MES,
            ANYO: ANYO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



export const ObtenerLicenciasInfoEnAPI = (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID_SOCIO, ID, ID_TALLER, BAJA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextInfotechnic/ObtenerLicencias', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: REGSPAGE,
            PAGE: PAGE,
            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID: ID,
            ID_TALLER: ID_TALLER,
            ID_SOCIO: ID_SOCIO,
            BAJA: BAJA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




export const EnviarCredencialesInfoEnAPI = (ID) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextInfotechnic/EnviarCredenciales', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID: ID,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




export const BajaLicenciaInfoEnAPI = (ID) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextInfotechnic/BajaLicencia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID: ID,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



export const CrearLicenciaInfoEnAPI = (payload) => {
    const { USUARIO, PWD, ID_SOCIO, ID_TALLER, ID_IDIOMA, CORREO_RECUPERACION_PWD, ID_PROGRAMA, OBSERVACIONES, CIF_TALLER, ID_DISENYO, PROVIENE_RED, ID_VERSION,
        RAZON,DIRECCION,CODIGO_POSTAL,POBLACION,PROVINCIA,PAIS,MAIL,TELEFONO,EMPRESA_SOCIO } = payload
        
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextInfotechnic/CrearLicencia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            USUARIO: USUARIO,
            PWD: PWD,
            CIF_TALLER:CIF_TALLER,
            RAZON:RAZON,
            DIRECCION:DIRECCION,
            CODIGO_POSTAL:CODIGO_POSTAL,
            POBLACION:POBLACION,
            PROVINCIA:PROVINCIA,
            PAIS:PAIS,
            MAIL:MAIL,
            TELEFONO:TELEFONO,


            ID_SOCIO: ID_SOCIO,
            EMPRESA_SOCIO:EMPRESA_SOCIO,
            ID_IDIOMA: ID_IDIOMA,
            CORREO_RECUPERACION_PWD: CORREO_RECUPERACION_PWD,
            OBSERVACIONES: OBSERVACIONES,
            ID_DISENYO: ID_DISENYO,
            ID_VERSION: ID_VERSION,
            PROVIENE_RED: PROVIENE_RED,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


export const DisenyosInfoEnAPI = (ID_PROGRAMA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextInfotechnic/Disenyos', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_PROGRAMA: ID_PROGRAMA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


export const ModificarLicenciaInfoEnAPI = (payload) => {
    const { ID, ID_IDIOMA, CORREO_RECUPERACION_PWD, OBSERVACIONES, ID_DISENYO, PROVIENE_RED,USUARIO,PWD } = payload
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextInfotechnic/ModificarLicencia', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID: ID,
            ID_IDIOMA: ID_IDIOMA,
            CORREO_RECUPERACION_PWD: CORREO_RECUPERACION_PWD,
            OBSERVACIONES: OBSERVACIONES,
            ID_DISENYO: ID_DISENYO,
            PROVIENE_RED: PROVIENE_RED,
            USUARIO: USUARIO,
            PWD: PWD,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


export const VersionesInfoEnAPI = (ID_PROGRAMA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextInfotechnic/Versiones', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_PROGRAMA: ID_PROGRAMA,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


export const GetEstadisticasEvolucionMarcaDetalleEnAPI = (ID_SOCIO, ID_DEPARTAMENTO, ANYO, MARCA) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextAssist/GetEstadisticasEvolucionMarcaDetalle', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ID_SOCIO: ID_SOCIO,
            ID_DEPARTAMENTO: ID_DEPARTAMENTO,

            MARCA: MARCA,
            ANYO, ANYO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



export const GetEstadisticasTecnicoSatisfaccionEnAPI = (ID_SOCIO,ID_DEPARTAMENTO, MES, ANYO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Estadisticas/GetEstadisticasTecnicoSatisfaccion', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({

            ID_DEPARTAMENTO: ID_DEPARTAMENTO,
            ID_SOCIO: ID_SOCIO,
            MES: MES,
            ANYO: ANYO,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




export const GetSertecMarketingSociosEnAPI = (ORDERCOLUM, ORDERDIR, ID_SOCIO, ID, NOMBRE) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Marketing/GetSertecMarketingSocios', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            REGSPAGE: 1000,
            PAGE: 1,

            ORDERCOLUM: ORDERCOLUM,
            ORDERDIR: ORDERDIR,
            ID_SOCIO: ID_SOCIO,
            ID: ID,
            NOMBRE: NOMBRE,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




export const SetSertecMarketingSociosEnAPI = (ACCION, PAYLOAD) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Marketing/SetSertecMarketingSocios', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ACCION: ACCION,
            ID: PAYLOAD.ID,
            ID_SOCIO: PAYLOAD.ID_SOCIO,
            NOMBRE: PAYLOAD.NOMBRE,
            NOMBRE_ALTERNATIVO: PAYLOAD.NOMBRE_ALTERNATIVO,


            DIA_FECHA_UNICA: PAYLOAD.DIA_FECHA_UNICA,
            FECHA_UNICA: PAYLOAD.FECHA_UNICA,

            REPETICION: PAYLOAD.REPETICION,
            DIA_REPETICION: PAYLOAD.DIA_REPETICION,


            ENTRE_DOS_FECHAS: PAYLOAD.ENTRE_DOS_FECHAS,
            FECHA_DESDE: PAYLOAD.FECHA_DESDE,
            FECHA_HASTA: PAYLOAD.FECHA_HASTA,
            OBSERVACIONES: PAYLOAD.OBSERVACIONES,



            IMAGEN: PAYLOAD.IMAGEN,
            IMAGEN_NOMBRE: PAYLOAD.IMAGEN_NOMBRE,
            DOCUMENTO: PAYLOAD.DOCUMENTO,
            DOCUMENTO_NOMBRE: PAYLOAD.DOCUMENTO_NOMBRE,


            URL: PAYLOAD.URL,
            ORDEN: PAYLOAD.ORDEN,

            REFERENCIA: PAYLOAD.REFERENCIA,
            TIPO_ACCION_CLICK: PAYLOAD.TIPO_ACCION_CLICK,
            Token: obtenerToken()
        }),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined && res !== null) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



export const ObtenerConfiguracionMensajeriaEnAPI = (ID_SOCIO) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Mensajeria/ObtenerConfiguracionMensajeria', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_SOCIO: ID_SOCIO,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}


export const ModificarConfiguracionMensajeriaEnAPI = (ID_SOCIO, PERMISO_TELEGRAM) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/Mensajeria/ModificarConfiguracionMensajeria', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                ID_SOCIO: ID_SOCIO,
                PERMISO_TELEGRAM: PERMISO_TELEGRAM,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}




export const PostCSVEnAPI = (REGISTROS,ENCABEZADOS) => {
    controller = new AbortController();
    return fetch(endpointBackOffice + 'api/NextGroup/Consumos/PostCSV', {
        method: 'POST',
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                REGISTROS: REGISTROS,
                ENCABEZADOS:ENCABEZADOS,
                Token: obtenerToken()
            }
        ),
        dataType: "json",
    }).then(res => res.json())
        .catch(error => console.error('Error:', error))
        .then(function (res) {
            if (res !== undefined) {
                if (!res.OK) {
                    MSGERROR(res.MENSAJE_ERROR)
                }
                return res
            }
        })
}



const abortFetch = () => {
    controller.abort()
}


const END_POINT_ACTUAL = () => {
    return endpoint1;
}

export const ObtenerEndPoint = () =>{
    return endpointBackOffice;
}

export {
    abortFetch,
    LoginEnAPI,
    LogoutEnAPI,
    obtener_registros_paginadosEnAPI,
    obtener_fabricantesEnAPI,
    obtener_modelosEnAPI,
    obtener_motorizacionesEnAPI,
    obtener_tipo_tareaEnAPI,
    obtener_grupo_montajeEnAPI,
    buscar_matriculaEnAPI,
    buscar_bastidorEnAPI,
    nueva_tareaEnAPI,
    obtener_estados_tareaEnAPI,
    obtener_registrosEnAPI,
    insertar_ficheroEnAPI,
    GetSmartPackEnAPI,
    GetDetalleSmartPackEnAPI,
    obtener_vehiculoEnAPI,
    obtener_fichero_tecnico_EnAPI,
    obtener_fichero_taller_EnAPI,
    obtener_paises_EnAPI,
    obtener_imagen_vehiculoEnAPI,
    obtener_registros_taller_EnAPI,
    recuperar_contrasenyaEnAPI,
    obtener_usuario_EnAPI,
    actualizar_usuario_EnAPI,
    obtener_registros_idiomas_EnAPI,
    obtener_configuracion_EnAPI,
    obtener_anyos_EnAPI,
    obtener_tarea_EnAPI,
    END_POINT_ACTUAL,
    obtener_grado_satisfaccionEnAPI,
    hay_feedback_pendientesEnAPI,
    actualizar_feedbackEnAPI,
    documento_consutlaEnAPI,
    obtener_conectorEnAPI,


    



    PublicarNoticiaEnAPI,MaquetarNoticiaEnAPI,GetFamiliasEnAPI,SetFamiliaEnAPI,GetSubFamiliasEnAPI,SetSubFamiliaEnAPI,
    GetArticulosEnAPI,SetArticulosEnAPI,GetGruposMontajeEnAPI,SetMarcaProveedorEnAPI,GetCategoriaDocumentoEnAPI,
    GetCategoriaNoticiaEnAPI,GetEstadoNoticiaEnAPI,GetMarcasEnAPI,GetPlantillaTipoNoticiaEnAPI,GetTipoDocumentoEnAPI,
    GetTipoEntidadEnAPI,GetTipoNoticiaEnAPI,SetCategoriaDocumentoEnAPI,SetCategoriaNoticiaEnAPI,SetEstadoNoticiaEnAPI,
    SetMarcaEnAPI,SetPlantillaTipoNoticiaEnAPI,SetTipoDocumentoEnAPI,SetTipoEntidadEnAPI,SetTipoNoticiaEnAPI,
    ObtenerListaMarcasTecdocEnAPI,CruzarReferenciasPorGrupoMontajeEnAPI,CruzarReferenciasPorGrupoMontajeImpresionEnAPI,
    DarBajaLicenciaSertecEnAPI,EnviarCorreoRecuperacionUsuarioSertecEnAPI,GetCarpetaDocDocumentoEnAPI,GetCarpetaDocEnAPI,
    GetDocumentoProveedorEnAPI,GetNoticiasEnAPI,GetPaisesEnAPI,GetProveedorDetalleEnAPI,GetProveedoresEnAPI,
    GetSociosExcluidosCarpetaEnAPI,GetSociosExcluidosDocumentoEnAPI,ObtenerGruposMontajeMarcasTecdocEnAPI,
    ObtenerSocioEnAPI,SetCarpetaDocDocumentoEnAPI,SetCarpetaDocEnAPI,SetDocumentoProveedorEnAPI,SetNoticiaEnAPI,
    SetSociosExcluidosCarpetaEnAPI,SetSociosExcluidosDocumentoEnAPI,SetNoticiaImagenEnAPI,GetIdiomasEnAPI,
    GetNextAssistBODepartamentosEnAPI,GetRolesEnAPI,GetUsuariosEnAPI,ObtenerRedesEnAPI,SetUsuarioEnAPI,
    RecuperarPwdEnAPI,ValidarTarifaEnAPI,GuardarTarifaEnAPI,ObtenerTarifaPorProveedorMarcaEnAPI,
    ObtenerFamiliasByMarcaEnAPI,TarifaProvedorMarcaDescagarCSVEnAPI,GetLicenciasSertecSocioEnAPI,
    ObtenerClientesSocioEnAPI,ObtenerListadoLicenciasSertecCSVEnAPI,ObtenerListadoLicenciasSertecHTMLEnAPI,
    ObtenerListadoLicenciasSertecPDFEnAPI,EstadisticasSertecMensualesPorUsuarioCSVEnAPI,
    GetEstadisticasMatriculasPorUsuarioDetalleEnAPI,GetEstadisticasMatriculasPorUsuarioEnAPI,
    GetEstadisticasSertecMensualesPorUsuarioEnAPI,GetEstadisticasTotalesAnnosEnAPI,
    CargaMasivaClientesEnAPI,CrearLicenciaClienteEnAPI,ModificarLicenciaClienteEnAPI,
    CrearLicenciaMostradorEnAPI,ModificarLicenciaMostradorEnAPI,GetCSVEnAPI,GetListaHTMLEnAPI,
    GetListaPDFEnAPI,ObtenerLicenciasSertecFacturacionEnAPI,ObtenerLicenciasSertecFacturacionDesgloseEnAPI,
    GetEstadisticasTotalesEnAPI,ObtenerHistoricoTarifasEnAPI,GetMarcaProveedorEnAPI,ObtenerTarifaPorActualizacionEnAPI,
    TarifaActualizacionDescagarCSVEnAPI,CrearLicenciaUsuarioNextAssistEnAPI,DarBajaUsuarioNextAssistEnAPI,
    EnviarCredencialesUsuarioTallerEnAPI,EnviarMailBienvenidaEnAPI,GetLicenciasFacturacionDesgloseEnAPI,
    GetLicenciasFacturacionDesgloseTareaHtmlEnAPI,GetLicenciasFacturacionDesgloseTareasEnAPI,GetUsuariosNextAssistEnAPI,
    NextAssistgetLicenciasFacturacionEnAPI,SetUsuariosNextAssistEnAPI,GetClientesERPSocioEnAPI,SetClientesERPSocioEnAPI,
    GetEjerciciosCSVEnAPI,GetEstadisticasAnyosEnAPI,GetEstadisticasEnAPI,GetEstadisticasEvolucionEnAPI,
    GetEstadisticasRankingEnAPI,GetEstadisticasTecnicoEnAPI,GetEstadisticasTecnicoTareasEnAPI,
    GetFamiliaCSVEnAPI,GetMarcasCSVEnAPI,GetTiposTareaCSVEnAPI,ObtenerEstadisticasCentrosTalleresRedEnAPI,
    ObtenerEstadisticasProveedoresRedTalleresEnAPI,ModificarReglasAlmacenesAlternativosSocioEnAPI,
    ObtenerReglasAlmacenesAlternativosSocioEnAPI,ActualizarReglasMarcasGruposMontajeEnAPI,
    ObtenerReglasMarcasGruposMontajeEnAPI,ActualizarReglasNeumaticosMarcasEnAPI,ObtenerNeumaticosMarcasEnAPI,
    ObtenerFiltrosEstadisticasConsumosEnAPI,GetEstadisticasNextAssistTecnicoNivelEnAPI
};